module.exports = __webpack_public_path__ + "img/facebook.d16c261b.png";